import React from 'react'
import PropTypes from 'prop-types'
import { ReactModal } from '../ReactModal/ReactModal'
import { InputsFormGroup } from '../InputsFormGroup/InputsFormGroup'
import { Button } from '../Button/Button'
import { polyglot } from '../../../index'

class StaticFormGroup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      labelSize: props.expandInputFields ? 3 : 6
    }
  }
  handleChange (value) {
    this.props.handleChanges(this.props.label, value)
  }
  render () {
    return <div className='form-group'>
      <label className={`col-xs-12 col-sm-${this.state.labelSize} control-label wordwrap`}>{this.props.label}</label>
      <div className={`col-xs-12 col-sm-${12 - this.state.labelSize}`}>
        <div className='col-xs-12 no-side-padding'>
          <div className='controls'>
            <StaticWithEdit handleSubmit={this.handleChange.bind(this)} label={this.props.label} value={this.props.value} editable={this.props.editable} />
          </div>
        </div>
      </div>
    </div>
  }
}

StaticFormGroup.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  editable: PropTypes.bool,
  expandInputFields: PropTypes.bool,
  handleChanges: PropTypes.func
}

class StaticWithEdit extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      value: props.value
    }
    this.editButtonClick = this.editButtonClick.bind(this)
    this.deleteButtonClick = this.deleteButtonClick.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
  }
  handleChange (name, value) {
    this._name = name
    this.setState({value: value})
  }
  toggleModal () {
    this.setState({modalIsOpen: !this.state.modalIsOpen})
  }
  editButtonClick () {
    if (this.state.editIsEnabled) {
      this.setState({
        editIsEnabled: !this.state.editIsEnabled
      }, this.props.onChangeHandle(this.state.value))
    } else {
      this.setState({
        editIsEnabled: !this.state.editIsEnabled
      })
    }
  }
  handleSubmit (e) {
    e.preventDefault()
    this.toggleModal()
    this.props.handleSubmit(this.state.value)
  }

  deleteButtonClick () {
    this.props.handleSubmit(null)
    this.toggleModal()
  }

  render () {
    return <div>
      <div className='pull-left'>
        <div className='form-control-static'>{this.props.value}</div>
      </div>
      {this.props.editable
        ? <div className='pull-right clearfix'>
          <button type='button' onClick={this.toggleModal} className='btn btn-sm btn-primary a-btn-slide-text'>
            <span className='glyphicon glyphicon-edit' aria-hidden='true' />
            <span><strong>{polyglot.t('staticFields.commonFields.edit')}</strong></span>
          </button>
        </div>
        : null
      }
      <ReactModal
        name={polyglot.t('staticFields.commonFields.edition')}
        toggleModal={this.toggleModal}
        modalIsOpen={this.state.modalIsOpen}
        footer={<Button text={polyglot.t('staticFields.commonFields.delete')} buttonType='btn-primary pull-right' type='button' onClick={this.deleteButtonClick} />}>
        <div>
          <form onSubmit={e => this.handleSubmit(e)}>
            <EditFieldModalForm
              toggleModal={this.toggleModal}
              label={this.props.label}
              handleSubmit={this.handleSubmit}
              handleChange={this.handleChange}
              savedData={this.state.value} />
          </form>
        </div>
      </ReactModal>
    </div>
  }
}

const EditFieldModalForm = (props) => {
  return <div className='form-horizontal'>
    <InputsFormGroup savedData={props.savedData} fields={[
      {
        'name': 'name',
        'placeholder': 'staticFields.commonFields.specify',
        'type': 'text'
      }
    ]} label={props.label} getFieldValue={props.handleChange} />
    <Button text={polyglot.t('staticFields.commonFields.save')} buttonType='btn-primary btn-block' type='submit' />
  </div>
}

EditFieldModalForm.propTypes = {
  savedData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  label: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired
}

StaticWithEdit.propTypes = {
  onChangeHandle: PropTypes.func,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  editable: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired
}

export { StaticFormGroup }



// WEBPACK FOOTER //
// ./src/components/common/StaticFormGroup/StaticFormGroup.js